// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"90b99108","839":"8ab0641e","844":"3038f14a","971":"f22b48e6"}[chunkId] + ".chunk.css";
};